<div class="container">
  <div class="row">
    <div class="col-12">

      <div [ngClass]="{'mt-5': true, 'module-section__name': !!description}">
        <span>{{ description }}</span>
      </div>

      <ng-content></ng-content>
      <app-button-navigation
              [previousVisible]="previousVisible"
              [previousEnabled]="previousEnabled"
              [previousLabel]="previousLabel"
              [nextVisible]="nextVisible"
              [nextEnabled]="nextEnabled"
              [nextLabel]="nextLabel"
              (previousClick)="goToPreviousStep()"
              (nextClick)="goToNextStep()"
      ></app-button-navigation>

    </div>
  </div>
</div>
